var map = {
	"./404.svg": 983,
	"./Categories.png": 732,
	"./Edit-menu.svg": 984,
	"./Egg.svg": 985,
	"./Emaier-Header.png": 986,
	"./Qr-4.png": 987,
	"./_duplicate.svg": 988,
	"./_overview.svg": 989,
	"./add-white.svg": 990,
	"./alert.svg": 991,
	"./all_category.svg": 992,
	"./archive.svg": 993,
	"./armchair.svg": 994,
	"./arrow-circle-right.svg": 995,
	"./arrow-left-circle.svg": 996,
	"./arrow-right-circle.svg": 997,
	"./arrow-right.svg": 998,
	"./asc-up-white.svg": 999,
	"./asc.png": 1000,
	"./asc.svg": 1001,
	"./back-arrow.svg": 1002,
	"./barcode-icon.svg": 1003,
	"./beverages.svg": 1004,
	"./blue-edit-pen.svg": 1005,
	"./blue-eye.svg": 1006,
	"./box-office.svg": 1007,
	"./broken-seat.jpg": 1008,
	"./calendar_list.svg": 1009,
	"./calender.svg": 376,
	"./chevron-down.svg": 1010,
	"./chevron-left.svg": 1011,
	"./cinema-mamagement-sidebar.svg": 1012,
	"./claendar.svg": 377,
	"./clock-1.svg": 1013,
	"./clock.svg": 1014,
	"./close-button.svg": 739,
	"./close-white.svg": 745,
	"./close-x.svg": 321,
	"./collapse-up.svg": 1015,
	"./collapse.svg": 1016,
	"./connection-lost.svg": 374,
	"./consumable-raw-material.svg": 1017,
	"./copy.svg": 1018,
	"./copy_image_icon.png": 1019,
	"./delete-red-light.svg": 1020,
	"./delete-red.svg": 746,
	"./delete.svg": 720,
	"./deliver-icon.svg": 1021,
	"./desc-down-white.svg": 1022,
	"./desc.svg": 1023,
	"./distributors-sidebar.svg": 1024,
	"./download.svg": 1025,
	"./dragndrop.svg": 1026,
	"./dragndrop2.svg": 1027,
	"./duplicate.svg": 1028,
	"./duplicateScreen.svg": 1029,
	"./e-wallet-icon-black.svg": 1030,
	"./edit-pen-blue.svg": 1031,
	"./edit-pen-white.svg": 1032,
	"./edit-pen.svg": 1033,
	"./edit.svg": 1034,
	"./email.png": 1035,
	"./empty-image.svg": 1036,
	"./excel.svg": 1037,
	"./external-link.svg": 1038,
	"./eye.svg": 1039,
	"./filter-icon.svg": 1040,
	"./flag.svg": 1041,
	"./fnb-app-order.svg": 1042,
	"./fnb-beverages.svg": 1043,
	"./fnb-brownie.svg": 1044,
	"./fnb-combo.svg": 1045,
	"./fnb-desert.svg": 1046,
	"./fnb-eatables.svg": 1047,
	"./fnb-make-your-combo.svg": 1048,
	"./fnb-popcorn.svg": 1049,
	"./fnbtransactionIcon.svg": 1050,
	"./fullscreen-icon.svg": 747,
	"./funnel.svg": 1051,
	"./globe.svg": 1052,
	"./green-tick.svg": 1053,
	"./grid-view.svg": 1054,
	"./hide-password.svg": 378,
	"./home-icon.svg": 1055,
	"./home.svg": 1056,
	"./icon-black-play.svg": 1057,
	"./icon-dot.svg": 1058,
	"./icon-fnb.svg": 1059,
	"./icon-marketing.svg": 1060,
	"./icon-no-seat.png": 1061,
	"./icon-no-seat.svg": 1062,
	"./icon-option.svg": 1063,
	"./icon-poin-of-sale.svg": 1064,
	"./icon-recliner.svg": 1065,
	"./icon-report.svg": 1066,
	"./icon-sofa-dark-1.svg": 1067,
	"./icon-sofa-dark.png": 1068,
	"./icon-sofa-dark.svg": 1069,
	"./icon-sofa.svg": 1070,
	"./importfile.svg": 1071,
	"./info.svg": 748,
	"./info2.svg": 1072,
	"./keyboard-icon.svg": 1073,
	"./kitchen_display.svg": 1074,
	"./language-icon.svg": 1075,
	"./left-caret.svg": 1076,
	"./link.svg": 1077,
	"./list-view.svg": 1078,
	"./loading.svg": 379,
	"./lock.svg": 1079,
	"./login-password.png": 380,
	"./login-user.png": 381,
	"./logout.svg": 749,
	"./masters-sidebar.svg": 1080,
	"./merchandise.svg": 1081,
	"./minus.svg": 1082,
	"./movie-pass-svg.svg": 730,
	"./movie-rolling.svg": 1083,
	"./mulitSchedule.svg": 1084,
	"./multicurrency.svg": 1085,
	"./multifnb.svg": 1086,
	"./nav-plus.svg": 1087,
	"./new_filter_icon.svg": 1088,
	"./no-image.svg": 1089,
	"./no-schedule.svg": 149,
	"./non-veg-mark.png": 1090,
	"./non-veg-mark.svg": 1091,
	"./notification.svg": 1092,
	"./open-link-blue.svg": 1093,
	"./openPlanned.svg": 1094,
	"./overview.svg": 1095,
	"./overview2.svg": 1096,
	"./pdf-icon.svg": 1097,
	"./pdf.svg": 1098,
	"./pickup-ticket-icon.svg": 1099,
	"./pickupfnb.svg": 1100,
	"./play.svg": 1101,
	"./plus.svg": 1102,
	"./pointofsale-1.svg": 1103,
	"./pointofsale-2.svg": 1104,
	"./pointofsale.png": 1105,
	"./portfolio.svg": 1106,
	"./pos-fnb-no-itmes.svg": 733,
	"./pos-refresh.svg": 1107,
	"./primary/chevron-down.svg": 1108,
	"./primary/download.svg": 1109,
	"./primary/edit.svg": 1110,
	"./primary/filter.svg": 1111,
	"./primary/printer.svg": 1112,
	"./print-icon.svg": 1113,
	"./print.svg": 1114,
	"./question.svg": 1115,
	"./question1.svg": 1116,
	"./question2.svg": 750,
	"./question3.svg": 1117,
	"./recliner-1.svg": 1118,
	"./recliner.png": 1119,
	"./refund-icon.svg": 1120,
	"./reload-icon-pos.svg": 1121,
	"./reload-icon.svg": 1122,
	"./restore.svg": 1123,
	"./right-caret.svg": 1124,
	"./role-management-sidebar.svg": 1125,
	"./save.svg": 1126,
	"./schedule-icon.svg": 1127,
	"./school-calendar.svg": 1128,
	"./search-global-white.svg": 1129,
	"./search-global.svg": 1130,
	"./search.svg": 751,
	"./searchIcon.svg": 1131,
	"./seat-icon-2.svg": 1132,
	"./seat-icon.svg": 1133,
	"./seat-icons/3-wheelChair.png": 1134,
	"./seat-icons/block_seat_new.png": 1135,
	"./seat-icons/broken-seat-1.svg": 1136,
	"./seat-icons/broken-seat-2.svg": 1137,
	"./select-food.png": 752,
	"./settings.svg": 1138,
	"./show-password.svg": 382,
	"./slider-triangle.svg": 742,
	"./snack.svg": 753,
	"./sort.svg": 1139,
	"./star-empty.svg": 1140,
	"./star-fill.svg": 1141,
	"./success-tick.svg": 1142,
	"./suitcase.svg": 1143,
	"./swap.svg": 1144,
	"./tick-green-item.svg": 754,
	"./tick-green.svg": 1145,
	"./ticket-icon.svg": 1146,
	"./trash.svg": 1147,
	"./unpaid-reservation.svg": 724,
	"./updown-white.svg": 1148,
	"./updown.svg": 1149,
	"./user-attribute.svg": 1150,
	"./user-attributes.svg": 1151,
	"./user-female.svg": 1152,
	"./user-male-white.svg": 1153,
	"./user-male.svg": 1154,
	"./user-profile.svg": 1155,
	"./userProfile.png": 1156,
	"./veg-food-mark-white.png": 1157,
	"./veg-foog-mark-trans.png": 1158,
	"./view.png": 1159,
	"./view.svg": 1160
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 982;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 982
// module chunks = 38